<template>
  <v-container
      :fluid="true"
      fill-height
  >
    <v-row>
      <v-spacer v-if="$vuetify.display.lgAndUp"/>
      <v-col
          md="12"
          lg="10"
      >
        <v-alert
            :closable="closable"
            :model-value="visible"
            :type="type"
            :title="title"
            :text="text"
            close-label="Close Alert"
            @update:model-value="$emit('update:visible', $event)"
        />
      </v-col>
      <v-spacer v-if="$vuetify.display.lgAndUp"/>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: "AlertCard",
  emits: ['update:visible'],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'error'
    },
    title: {
      type: String,
      default: 'Error'
    },
    text: {
      type: String,
      default: ''
    },
    closable: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>

</style>